// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/discovery-ads/date-picker-ads-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("resources/images/discovery-ads/powerup-menu-ads-background-dark.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B7zFsNGRPl5amS {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  color: var(--ds-text, #172b4d);
  border-radius: 3px;
}
:where(html[data-color-mode='dark']) .B7zFsNGRPl5amS {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.B7zFsNGRPl5amS.O3HDUCxtG33uEA {
  min-height: 269px;
  flex: 1 0 31%;
  margin-right: 2%;
  max-width: 32%;
  margin-bottom: 24px;
}
.B7zFsNGRPl5amS.O3HDUCxtG33uEA:nth-of-type(3n) {
  margin-right: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .B7zFsNGRPl5amS.O3HDUCxtG33uEA {
    flex: 1 0 48%;
    max-width: 49%;
  }
  .B7zFsNGRPl5amS.O3HDUCxtG33uEA:nth-of-type(3n) {
    margin-right: 2%;
  }
  .B7zFsNGRPl5amS.O3HDUCxtG33uEA:nth-of-type(2n) {
    margin-right: 0;
  }
  .B7zFsNGRPl5amS.O3HDUCxtG33uEA.wMah01IczGuhQG:nth-of-type(3n) {
    display: none;
  }
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .B7zFsNGRPl5amS.O3HDUCxtG33uEA {
    flex: auto;
    height: auto;
    margin-right: 0;
    max-width: none;
    width: 100%;
  }
}
.NwTGWKiy_dtxL7,
.Gt8MnmgFx9oSpf {
  background-color: var(--ds-background-neutral, #091e420f);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 3px;
  border: 1px solid var(--ds-border, #dadee5);
}
.NwTGWKiy_dtxL7 button.czGWo9OpeuSlc3,
.Gt8MnmgFx9oSpf button.czGWo9OpeuSlc3 {
  width: 32px;
  height: 32px;
  background-color: var(--ds-surface-overlay, #ffffff);
  border-radius: 8px;
}
.py7a_T387fsxVc {
  margin: 12px 0 6px 0;
  height: 240px;
}
.NwTGWKiy_dtxL7 .YalxKcG8nvyvHp {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}
.NwTGWKiy_dtxL7 .YalxKcG8nvyvHp p {
  font-size: 14px;
  margin-top: 12px;
}
.NwTGWKiy_dtxL7.O3HDUCxtG33uEA .YalxKcG8nvyvHp {
  padding: 48px 16px 8px 16px;
}
.NwTGWKiy_dtxL7.seo_4uEC5jCXwB .YalxKcG8nvyvHp {
  padding: 24px 16px 8px 16px;
}
.NwTGWKiy_dtxL7.py7a_T387fsxVc .YalxKcG8nvyvHp {
  margin-top: 30px;
}
.wWp2bh5aD_LTeo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
}
.wWp2bh5aD_LTeo .Bo94ZM6xagoQHm {
  border-radius: 3px;
  background: var(--gradient-i, linear-gradient(180deg, #5e3eff 0%, rgba(190, 102, 232, 0.47) 61.46%, rgba(202, 118, 241, 0) 100%));
  display: flex;
  justify-content: space-between;
  height: 100%;
  padding: 4px 4px 6px 6px;
}
.wWp2bh5aD_LTeo .Bo94ZM6xagoQHm .czGWo9OpeuSlc3 {
  align-self: flex-start;
  position: absolute;
  top: 4px;
  left: 252px;
}
.wWp2bh5aD_LTeo .Ey4rUlz6XNyJYS {
  padding: 0 16px 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.wWp2bh5aD_LTeo .Ey4rUlz6XNyJYS a.w5waq5uLyBJIHB {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 3px;
  background-color: var(--ds-background-neutral, #091e420f);
  text-decoration: none;
  color: inherit;
}
.wWp2bh5aD_LTeo .Ey4rUlz6XNyJYS a.K9Bwkh6s97z8Cz {
  font-size: 10px;
  text-decoration: underline;
  color: inherit;
}
.wWp2bh5aD_LTeo.py7a_T387fsxVc,
.wWp2bh5aD_LTeo.seo_4uEC5jCXwB {
  background: var(--gradient, linear-gradient(var(--ds-surface, #ffffff), var(--ds-surface, #ffffff))) padding-box, var(--border-gradient, linear-gradient(to bottom, #d5cdff66, #edc6ff6a)) border-box;
  border-radius: 3px;
  border: 1px solid transparent;
}
.wWp2bh5aD_LTeo.py7a_T387fsxVc .Bo94ZM6xagoQHm img {
  margin: 8px 10px 8px 20px;
  width: 80%;
}
.wWp2bh5aD_LTeo.py7a_T387fsxVc .Ey4rUlz6XNyJYS p {
  margin: 0;
  font-size: 10px;
}
.wWp2bh5aD_LTeo.O3HDUCxtG33uEA {
  background: var(--gradient, linear-gradient(var(--ds-surface, #ffffff), var(--ds-surface, #ffffff))) padding-box, var(--border-gradient, linear-gradient(to bottom, #8270db, #b970db, #b970db33)) border-box;
  border-radius: 3px;
  border: 0.5px solid transparent;
}
.wWp2bh5aD_LTeo.O3HDUCxtG33uEA .Bo94ZM6xagoQHm img {
  margin: 12px 16px 8px 12px;
  width: 80%;
}
@media only screen and (min-width: 901px) and (max-width: 1280px) {
  .wWp2bh5aD_LTeo.O3HDUCxtG33uEA .Bo94ZM6xagoQHm img {
    width: 70%;
  }
}
@media only screen and (max-width: 750px) {
  .wWp2bh5aD_LTeo.O3HDUCxtG33uEA .Bo94ZM6xagoQHm img {
    max-width: 350px;
  }
}
.wWp2bh5aD_LTeo.seo_4uEC5jCXwB .Bo94ZM6xagoQHm img {
  margin: 12px 10px 12px 20px;
  max-width: 180px;
  width: 80%;
  height: 120px;
}
@media only screen and (max-width: 750px), only screen and (min-width: 751px) and (max-width: 900px), only screen and (min-width: 901px) and (max-width: 1280px) {
  .wWp2bh5aD_LTeo.seo_4uEC5jCXwB .Bo94ZM6xagoQHm img {
    width: 75%;
  }
}
.Gt8MnmgFx9oSpf.tcogIAg1eiYifQ .tt36yC_AqRbh1A {
  font-size: 16px;
  font-weight: 600;
  padding-left: 16px;
  margin: 14px 0 6px 0;
}
.Gt8MnmgFx9oSpf.tcogIAg1eiYifQ .pmthw6EKTilk_B {
  width: 100%;
}
.Gt8MnmgFx9oSpf.tcogIAg1eiYifQ .kKH0bIAVmENSnp {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 16px 8px 16px;
}
.Gt8MnmgFx9oSpf.tcogIAg1eiYifQ .PEGw1roPhWIK0U {
  justify-content: start;
  text-align: left;
}
.Gt8MnmgFx9oSpf.tcogIAg1eiYifQ .mCjkEcKPmBzcKv {
  align-self: flex-start;
  position: absolute;
  top: 4px;
  left: 252px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `B7zFsNGRPl5amS`,
	"templatesContainer": `O3HDUCxtG33uEA`,
	"isFeatured": `wMah01IczGuhQG`,
	"thankYouContainer": `NwTGWKiy_dtxL7`,
	"feedbackContainer": `Gt8MnmgFx9oSpf`,
	"closeButton": `czGWo9OpeuSlc3`,
	"viewSwitcherContainer": `py7a_T387fsxVc`,
	"thankYouContentContainer": `YalxKcG8nvyvHp`,
	"leftHandNavContainer": `seo_4uEC5jCXwB`,
	"adContainer": `wWp2bh5aD_LTeo`,
	"adImageContainer": `Bo94ZM6xagoQHm`,
	"adContentContainer": `Ey4rUlz6XNyJYS`,
	"buttonLink": `w5waq5uLyBJIHB`,
	"link": `K9Bwkh6s97z8Cz`,
	"powerupMenuContainer": `tcogIAg1eiYifQ`,
	"feedbackTitle": `tt36yC_AqRbh1A`,
	"feedbackHeader": `pmthw6EKTilk_B`,
	"feedbackOptionsContainer": `kKH0bIAVmENSnp`,
	"feedbackButton": `PEGw1roPhWIK0U`,
	"feedbackCloseButton": `mCjkEcKPmBzcKv`
};
export default ___CSS_LOADER_EXPORT___;
